export interface OfferRequest {
  offer_reference: string;
}
export interface ItemOfferRequest {
  requestSource: string;
  channelCode: string;
  channelGroupCode: string;
  clientCode: string;
  clientGroupCode: string;
  item: {
    itemCode: string;
    manufactorCode: string;
    model: string;
    serialNumber: string;
    purchasePrice: number;
    currency: string;
    warranty: number;
    is_item_owned: boolean;
  };
  address: {
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressLine4: string;
    postalCode: string;
    countryCode: string;
  };
  personGid: string;
  otherIds: {
    otherId3: string;
    otherId3CategoryCode: string;
  };
}
export interface ItemOffer {
  itemOfferHash: string;
  itemGid: string;
  offerReference: string;
  periodOfCover: number;
  fee: number;
  paymentType: string;
  numberOfPayments: number;
  firstPayment: number;
  subsequentPayment: number;
  itemUrn?: string;
}

export const ItemOffer = undefined;
